import React, { useState } from 'react';
import './App.css';
import NavbarCustom from './components/NavbarCustom';
import MainContent from './components/MainContent';

function App() {
  const [currentSection, setCurrentSection] = useState<string>("O firmie");

  return (
    <div className="App">
      <NavbarCustom setCurrentSection={setCurrentSection}></NavbarCustom>
      <MainContent section={currentSection}></MainContent>
    </div>
  );
}

export default App;
